/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import iconTicket from './IconTicket_NoLoop_01.json';

const IconTicket = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(iconTicket))} {...props}/>
    );
}

export default IconTicket;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/iconTicket.jsx